export const createAsync = (storeOptions) => {
    const store = new Map();
    const toKey = (key) => storeOptions.namespace != null ? `${storeOptions.namespace}|${key}` : key;
    const _get = (key) => {
        key = toKey(key);
        if (store.has(key)) {
            const entry = store.get(key);
            if (Date.now() > entry.createdAt + entry.expireTime) {
                return null;
            }
            return entry.data;
        }
        else {
            return null;
        }
    };
    const get = async (key) => {
        return _get(key);
    };
    const set = async (key, value, options) => {
        key = toKey(key);
        const entry = {
            data: value,
            createdAt: Date.now(),
            expireTime: options?.expireTime ?? storeOptions.defaultExpireTime,
        };
        store.set(key, entry);
    };
    const setAdd = async (key, value) => {
        key = toKey(key);
        const val = await get(key);
        if (val != null) {
            val.add(value);
        }
        else {
            set(key, new Set([value]), {
                expireTime: Infinity,
            });
        }
    };
    const setRemove = async (key, value) => {
        key = toKey(key);
        const val = await get(key);
        if (val != null) {
            val.delete(value);
            if (val.size === 0) {
                del(key);
            }
        }
    };
    const setMembers = async (key) => {
        const value = await get(key);
        if (value) {
            return [...value];
        }
        return [];
    };
    const del = async (key) => {
        key = toKey(key);
        store.delete(key);
    };
    const getAndSetIfNotExists = async (key, value, options) => {
        const cached = _get(key);
        if (cached == null) {
            await set(key, value, options);
            return null;
        }
        else {
            return cached;
        }
    };
    const flush = async () => {
        store.clear();
    };
    const backend = {
        get,
        set,
        setAdd,
        setRemove,
        setMembers,
        del,
        getAndSetIfNotExists,
        flush,
    };
    return backend;
};
export const create = (storeOptions) => {
    const store = new Map();
    const toKey = (key) => storeOptions.namespace != null ? `${storeOptions.namespace}|${key}` : key;
    const get = (key) => {
        key = toKey(key);
        if (store.has(key)) {
            const entry = store.get(key);
            if (Date.now() > entry.createdAt + entry.expireTime) {
                return null;
            }
            return entry.data;
        }
        else {
            return null;
        }
    };
    const set = (key, value, options) => {
        key = toKey(key);
        const entry = {
            data: value,
            createdAt: Date.now(),
            expireTime: options?.expireTime ?? storeOptions.defaultExpireTime,
        };
        store.set(key, entry);
    };
    const setAdd = (key, value) => {
        key = toKey(key);
        const val = get(key);
        if (val != null) {
            val.add(value);
        }
        else {
            set(key, new Set([value]), {
                expireTime: Infinity,
            });
        }
    };
    const setRemove = (key, value) => {
        key = toKey(key);
        const val = get(key);
        if (val != null) {
            val.delete(value);
            if (val.size === 0) {
                del(key);
            }
        }
    };
    const setMembers = (key) => {
        const value = get(key);
        if (value) {
            return [...value];
        }
        return [];
    };
    const del = (key) => {
        key = toKey(key);
        store.delete(key);
    };
    const keys = () => {
        return Array.from(store.keys());
    };
    const backend = {
        get,
        set,
        setAdd,
        setRemove,
        setMembers,
        del,
        keys,
    };
    return backend;
};
//# sourceMappingURL=memory.js.map